module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-cove-timber-hamilton-0.86dde651.jpg";